<template>
  <el-main>
    繳費正在開發中
  </el-main>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>